<template>
    <div>
        <v-server-table :ref="'userLoginTable'" :url="`/users/logins/${user_id}`" :columns="columns" :options="options">

            <template slot="created_at" slot-scope="props">
                {{ props.row.created_at | moment('timezone', userTimezone, "MM/DD/YYYY hh:mm a") }}
            </template>

        </v-server-table>
    </div>
</template>

<script>
    export default {
        props: {
            user_id: {
                type: Number,
                required: true
            },
        },

        data() {
            return {
                userTimezone: this.$root.timezone,
                columns: ['created_at'],
                options: {
                    filterable: false,
                    headings: {
                        created_at: 'Timestamp',
                    },
                    orderBy: {
                        ascending: false,
                        column: 'login_history.created_at',
                    },
                    texts:{
                        filterPlaceholder:"Search Login History",
                    },
                    responseAdapter: (response) => {
                        //Emit the count
                        this.$emit('loginCount', response.data.count);

                        //Send it
                        return response.data;
                    },
                    uniqueKey: 'id',
                },
            }
        },

        computed: {

        },

        methods: {

        },

        mounted() {

        }
    }
</script>
